import { AxiosResponse } from 'axios';
import SearchService from '../../../Services/SearchService';
import { BluecoinData, BluecoinsData, BluecoinStatus, FiltersBluecoin } from './types';
import { ISimpleSelectOption } from '../../Forms/ArrayFields/interfaces';
import configJs from '../../../../config';
import { getRequest, postRequest } from '../../../Services/HttpService';
import { ICustomer } from '../../../store/recoil/customers';

const svgIconPath = {
  stroke: `M19.8732948,0 C26.4492542,0 32.7405037,2.2997614 37.7477037,6.50107234 C40.4148247,8.73893069 40.7630042,12.7154325 38.5253843,15.3828378 C37.8309506,16.2106532 36.9690791,16.8150985 36.0308588,17.1881963 L35.9984422,17.200192 L36.0387431,17.4092208 C36.3370506,19.2833622 35.7863128,21.2617087 34.4030156,22.7281845 L34.1502652,22.9815354 C33.4532354,23.6422997 32.6448614,24.1126574 31.7893397,24.3943269 L31.5727776,24.4576644 L31.6111161,24.5897479 C31.85912,25.4914499 32.0060249,26.4350328 32.0388761,27.4075405 L32.0459346,27.8260627 C32.0459346,34.5495426 26.5960581,40 19.8732948,40 C13.1505315,40 7.700655,34.5495426 7.700655,27.8260627 C7.700655,26.7054827 7.85204045,25.6202644 8.13547345,24.5897479 L8.21500657,24.3133149 L8.09239225,24.2784493 C7.31713326,24.025882 6.58060788,23.6188605 5.93060918,23.0566912 L5.6574752,22.8062607 C4.05212869,21.2466603 3.45486398,19.0401946 3.87746999,16.9995716 L3.89020189,16.944537 C3.05161027,16.5983407 2.28586916,16.0722046 1.64710618,15.370788 L1.41364693,15.0995534 C-0.783176647,12.3984428 -0.374604671,8.42769287 2.32621798,6.23063512 C7.28316643,2.1982704 13.4434945,0 19.8732948,0 Z`,
  body: `M20,20 C24.418278,20 28,23.581722 28,28 C28,32.418278 24.418278,36 20,36 C15.581722,36 12,32.418278 12,28 C12,23.581722 15.581722,20 20,20 Z M20,25 C18.3431458,25 17,26.3431458 17,28 C17,29.6568542 18.3431458,31 20,31 C21.6568542,31 23,29.6568542 23,28 C23,26.3431458 21.6568542,25 20,25 Z M19.9407664,12 C24.3530549,12 28.4805653,13.7476023 31.4561907,16.7735744 C32.2096171,17.5397486 32.1760266,18.7495842 31.3811643,19.4758179 C30.5863019,20.2020516 29.3311659,20.1696735 28.5777395,19.4034993 C26.3435019,17.131459 23.2529715,15.8229177 19.9407664,15.8229177 C16.6798101,15.8229177 13.6330578,17.0909566 11.4054386,19.3013941 C10.6423321,20.0586148 9.38687877,20.0761706 8.60130514,19.3406062 C7.81573152,18.6050417 7.79751834,17.3949003 8.56062487,16.6376796 C11.527579,13.6936096 15.5968617,12 19.9407664,12 Z M19.8704627,4 C25.5853713,4 30.9964899,5.97682454 35.2854989,9.52118473 C36.1315958,10.220384 36.2420496,11.4628073 35.5322043,12.2962147 C34.8223591,13.1296222 33.5610188,13.2384194 32.7149219,12.5392201 C29.1396397,9.58467101 24.6363581,7.93950327 19.8704627,7.93950327 C15.2106325,7.93950327 10.8008822,9.51186908 7.26166171,12.3474629 C6.40487358,13.0339144 5.14535779,12.9062461 4.44845444,12.0623077 C3.75155109,11.2183693 3.88116331,9.97774322 4.73795143,9.29129173 C8.98399455,5.88939747 14.2828703,4 19.8704627,4 Z`,
};

export const arrayToObject = (bluecoins: BluecoinData[]): BluecoinsData => {
  const bluecoinsData: BluecoinsData = {};
  bluecoins.forEach((bluecoin: BluecoinData) => {
    bluecoinsData[bluecoin.bluecoinId] = bluecoin;
  });
  return bluecoinsData;
};

export const getBluecoinIcon = (
  bluecoinStatus: BluecoinStatus,
  isClicked = false,
  angle = 0,
  isStroke = true,
  setOpacity = 1
): string => {
  let svgXml = `data:image/svg+xml;utf8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='36px' opacity='${setOpacity}' height='36px' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'%3E%3Cg transform='rotate(${angle}, 20 20)'%3E`;

  if (isStroke) {
    svgXml += `%3Cpath id='Path' d="${svgIconPath.stroke}" fill="%23${configJs.bluecoinStatusColor[bluecoinStatus].stroke}" fill-opacity='1' stroke='none'/%3E`;
  }

  svgXml += `%3Cpath id='Shape' d='${svgIconPath.body}' fill='%23${
    isClicked
      ? configJs.statusColor.UNKNOWN.fill
      : configJs.bluecoinStatusColor[bluecoinStatus].fill
  }' fill-opacity='1' stroke='none'/%3E%3C/g%3E%3C/svg%3E`;
  return svgXml;
};

export const getBluecoinData = async (): Promise<BluecoinData[] | false> => {
  const response = await getRequest<AxiosResponse | false>(`/v1/bluecoin/list`, {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.status === 200) {
    return response.data.bluecoins;
  }
  return false;
};

export const getBluecoinDataFilter = async (
  data: FiltersBluecoin
): Promise<BluecoinData[] | false> => {
  const response = await postRequest<FiltersBluecoin, AxiosResponse | false>(
    `/v1/bluecoin/list`,
    data,
    {
      returnAxiosResponse: true,
    }
  );
  if (response && response.data && response.status === 200) {
    return response.data.bluecoins;
  }
  return false;
};

export const searchBluecoin = (bluecoins: BluecoinData[], filterString: string): BluecoinData[] => {
  if (filterString === '') {
    return [];
  }

  let tempString = String(filterString);

  tempString = tempString.replace(/[^\w\s]/g, '');

  const regexp = new RegExp(tempString.toLowerCase());

  return bluecoins.filter(
    (bluecoin: BluecoinData) =>
      bluecoin.name && regexp.test(SearchService.removeAccent(bluecoin.name.toLowerCase()))
  );
};

export const handleCustomerOptionsBluecoin = (
  customers: ICustomer[],
  selectedCustomers: number[]
): ISimpleSelectOption[] => {
  const filteredCustomers = customers.filter((customer: ICustomer) =>
    selectedCustomers.includes(customer.id)
  );

  const options: ISimpleSelectOption[] = [];
  filteredCustomers.forEach((customer: ICustomer) => {
    options.push({
      item: customer.name,
      value: customer.id,
      label: customer.label || undefined,
    });
  });

  return options;
};

export const getCountBluecoinIdByAttached = (data: BluecoinData[], bluecoinId: number): number => {
  const filteredBluecoinData = data.filter(
    (bluecoin: BluecoinData) => bluecoin.bluecoinId === bluecoinId && bluecoin.attached
  );

  return filteredBluecoinData.length;
};

export const hasBluecoinPosition = (data: BluecoinData): boolean => {
  return typeof data.position.latitude === 'number' && typeof data.position.longitude === 'number';
};
